<template>
  <div class="ReChannelBig card mt-2">
    <div v-if="bIsEdit" class="post-editor">
      <div slot="header">
        <h5><i class="tim-icons icon-send text-success mr-3"></i>Редактирование публикации</h5>
        <div class="bntGroup">
          <base-button type="primary" class="no-border my-0" simple icon>
            <i class="d-inline-block tim-icons icon-simple-remove" @click="showEdit(true)"></i>
          </base-button>
        </div>
      </div>
      <ReChannelPostAdd />
      <!--форма редактирования должна подставлять данные из поста -->
    </div>

    <div v-else class="channel-container">
      <div class="post-header">
        <div class="photo-container">
          <div class="channel-photo">
            <!--это дефолтная картинка для каналов, {{channel.icon}} ?? -->
            <img src="/img/icons/icon-channel.svg" alt class="avatar" />
          </div>
        </div>
        <div class="leftCol">
          <!--тут будет {{channel.title}}-->
          <p class="title">Реактор</p>
          <!--тут будет время создания поста{{date}}-->
          <p class="time-date">20 марта 2020 в 16:27</p>
          <span class="badge badge-pill badge-primary mt-1">Черновик</span>                

        </div>
        <div class="rightCol">
          <div class="bntGroup">
            <base-button type="primary" class="no-border my-0" simple icon>
              <base-button v-if="bCanEdit" @click="showEdit(false)" type="primary" class="no-border my-0" simple icon>
                <i class="d-inline-block tim-icons icon-pencil"></i>
              </base-button>
            </base-button>
            <base-button type="warning" class="no-border my-0" simple icon @click="addToFavs()">
              <i class="d-inline-block" :class="[isSaved ? 'tim-icons icon-shape-star' : 'tim-ic ic-star-filled']"></i>
              <!--при клике на "добавить в избранное" менять иконку на "fas fa-star" (избранное - это будет опция фильтра, которую можно выбирать при фильтрации постов в ленте)-->
            </base-button>
          </div>
        </div>
      </div>

      <div class="post-body">
        <p class="title">{{postContent.title}}</p>
        <p class="maintxt" :class="[isActive ? 'expand-hidden' : 'expand-visible']">
          Lorem ipsum, dolor sit amet consectetur adipisicing elit. Vel dolorem debitis ipsam assumenda nihil explicabo itaque suscipit sunt illo dolorum,
          architecto, consectetur delectus ratione ullam blanditiis? Ab minima culpa reprehenderit facere! Animi tenetur, labore sint illo alias aliquid ad molestias,
          temporibus placeat explicabo, recusandae ex voluptate voluptatum voluptatibus architecto esse a. Et iusto quae non molestiae unde odio atque saepe! Atque fugit odio
          doloribus quis omnis beatae vel vitae neque, illo soluta. Nesciunt dicta, ex expedita, explicabo sit suscipit, nulla et quas dolor cumque dignissimos tenetur!
          Recusandae labore commodi quas atque delectus, fugit veritatis? Non, neque, pariatur tempore praesentium ipsam voluptas quis excepturi totam aliquam eveniet
          mollitia similique? Facere impedit doloremque earum mollitia enim, alias ratione obcaecati corporis! Quisquam repudiandae est mollitia recusandae, placeat
          labore optio aspernatur? Quis, explicabo deserunt corporis nulla reprehenderit perferendis ipsum? Veniam similique soluta, sapiente veritatis enim fuga?
          Molestias, natus. Excepturi temporibus quod, expedita qui sequi repudiandae obcaecati tempore quo nostrum dignissimos odio debitis quae? Nemo, quaerat
          omnis nisi dolorum voluptatum voluptas architecto placeat soluta, incidunt temporibus est fuga illo iure. Fugiat dolorem odio maiores omnis? Maiores qui
          officiis nam ratione, natus illum quibusdam quidem ducimus nisi, ab minima mollitia sint numquam soluta veniam fugit quod.
        </p>
        <!--тут будет {{ channel.text }}-->

        <button class="expandBtn" @click="toggleText()">{{expandText.text}}</button>

        <el-carousel :autoplay="false" arrow="always" type="card" height="200px">
          <el-carousel-item v-for="item in 4" :key="item">
            <!--h3 class="medium">{{ item }}</h3-->
            <div class="medium"></div>
          </el-carousel-item>
        </el-carousel>

        <div class="post-docs"></div>
      </div>

      <div class="post-footer">
        <div class="post-footer-container">
          <div class="social-state">
            <a href="#" type="button">
              <ReLike :liketype="'like'" :counter="'1000'"></ReLike>
              <!--:counter="postContent.like"-->
            </a>
            <a href="#" type="button">
              <ReLike :liketype="'dislike'" :counter="'100'"></ReLike>
              <!--:counter="postContent.dislike"-->
            </a>
            <a href="#" type="button" class="btn btn-simple text-info" @click="showComments()">
              <i class="tim-icons icon-chat-33">100+</i>
              <!--counter-->
            </a>
          </div>
          <div class="views-reached">
            <i class="tim-ic ic-eye">100</i>
          </div>
        </div>
      </div>

      <div class="comments-block card" :class="[isShown ? 'comments-hide' : 'comments-show']">
        <ReCommentsAll></ReCommentsAll>

        <form class="commentArea position-sticky">
          <div class="left_part">            
            <el-input
              type="textarea"
              autosize
              placeholder="Написать комментарий"
              v-model="textarea1"
            ></el-input>
          </div>
          <div class="right_part">
            <ReFileUpload type="file" @change="UploadFile" />
            <base-button class="btn btn-icon btn-simple btn-success">
              <i class="tim-icons icon-send"></i>
            </base-button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import ReCommentsAll from "src/our_components/ReCommentsAll.vue";
import ReLike from "src/our_components/ReLike.vue";
import { Carousel, CarouselItem, Input } from "element-ui";
import ReFileUpload from "src/our_components/ReFileUpload.vue";
import ReChannelPostAdd from "src/our_components/ReChannelPostAdd.vue";

export default {
  name: "ReChannelBig",
  components: {
    ReCommentsAll,
    ReLike,
    ReFileUpload,
    [Carousel.name]: Carousel,
    [CarouselItem.name]: CarouselItem,
    [Input.name]: Input,
    ReChannelPostAdd
  },
  props: {
    
  },
  data() {
    return {
      isActive: true,
      isShown: true,
      isSaved: true,
      bIsEdit: false,
      bCanEdit: true,

      expandText: {
        text: "Показать полностью"
      },
      postContent: {
        title: "Заголовок публикации",
        like: "",
        dislike: ""
      },
      textarea1: ""

      /*comments: [
        {userName: 'Имя Фамилия', userIcon: '', comDate: '', comText: '', }
      ]*/
    };
  },
  computed: {},
  methods: {
    toggleText(event) {
      this.isActive = !this.isActive;
      if (this.isActive) {
        this.expandText.text = "Показать полностью";
      } else this.expandText.text = "Скрыть";
    },
    showComments() {
      this.isShown = !this.isShown;
    },
    addToFavs() {
      this.isSaved = !this.isSaved;
    },
    UploadFile(files) {
      this.$GVO
        .UploadFile("uploadForm", "UploadTaskHelp", {
          obj: "FileUpload",
          flt: { BP_ID: "1", id: "1" }
        })
        .then(objApi => {
          //console.log(objApi);
          if (objApi.success) {
            // console.log(objApi.data);
          }
        })
        .catch(errorObjApi => {
          console.error(errorObjApi);
        });
    },
    showEdit() {
      this.bIsEdit = !this.bIsEdit;
      //возможно при закрытии формы редактирования (этим showEdit(true)) не просто закрывать, а отменять\стирать введенные данные форму?
    }
  }
};
</script>
<style scoped>
.ReChannelBig.card {
  padding: 15px 15px 0 15px;
}
.ReChannelBig .photo-container {
  max-width: 100px;
}
.ReChannelBig .channel-photo {
  padding: 0 20px 0 15px;
  width: 100%;
}
.ReChannelBig .channel-photo .avatar {
  min-width: 60px;
  min-height: 60px;
  margin-bottom: 0;
  background-color: transparent;
  box-shadow: 0 1px 20px 0px rgba(0, 0, 0, 0.1);
}
.ReChannelBig .time-date {
  opacity: 0.4;
}
.ReChannelBig .leftCol {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  padding-right: 10px;
}
.ReChannelBig .leftCol .badge {max-width: 100px;}
.ReChannelBig .rightCol,
.ReChannelBig .views-reached {
  display: flex;
  flex-shrink: 1;
}
.ReChannelBig .social-state {
  display: flex;
  flex-grow: 1;
  padding-right: 10px;
}
.ReChannelBig .social-state a {
  margin-right: 20px;
}
.ic-smile::before,
.ic-sad::before,
.ic-eye::before,
.icon-chat-33::before {
  margin-right: 5px;
  font-size: 1.4rem;
}
.ReChannelBig .post-header {
  display: flex;
  flex-direction: row;
  padding-bottom: 20px;
}
.ReChannelBig .title {
  font-size: 1.1rem;
}
.ReChannelBig .maintxt {
  margin-top: 20px;
}
.post-footer {
  margin-top: 20px;
  border-top: 1px solid #2b3553;
}
.post-footer-container {
  display: flex;
  padding: 20px 0;
}
.ReChannelBig .social-state .btn-simple {
  border: transparent;
  padding: 0;
}
.ReChannelBig .social-state .btn-simple:hover {
  box-shadow: none;
  opacity: 0.8;
}
.position-sticky {
  position: sticky;
  bottom: 0;
  z-index: 2;
  background-color: inherit;
}

/*===expand button===============================*/
.expand-hidden {
  height: 5rem;
  overflow: hidden;
  margin-bottom: 10px;
}
.expand-visible {
  height: auto;
  overflow: auto;
}
.expandBtn {
  background-color: transparent;
  border: none;
  outline: none;
  color: #9e77f3;
  padding-left: 0;
  margin-bottom: 10px;
}
.expandBtn:hover {
  color: #01b0e0;
}

/*===comments===============================*/
.comments-block {
  border-top: 1px solid #2b3553;
  padding: 20px 0 0 0;
}
.comments-block.card {
  box-shadow: none;
  margin-bottom: 0;
  border-radius: 0;
}
.comments-show {
  display: block;
}
.comments-hide {
  display: none;
}
.commentArea {
  display: flex;
  padding: 20px 0;
  border-top: 1px solid #2b3553;
}
.commentArea .btn,
.commentArea .fileinput {
  margin: 0 0 0 10px;
}
.left_part {
  display: flex;
  flex-direction: column;
  width: 100%;
  /*max-height: 40px;*/
  height: auto;
}
.right_part {
  display: flex;
  flex-shrink: 1;
}


/*===textarea===============================*/
.commentArea textarea.form-control {
  padding: 10px;
  border: 1px solid #2b3553;
  border-radius: 0.4285rem;
  max-height: none;
  height: auto;
  line-height: inherit;
}
.commentArea textarea.form-control:focus {
  border-color: #01b0e0;
}
.commentArea >>> .el-textarea__inner {
  height: 38px;
  resize: none;
  background-color: transparent;
  border: 1px solid #2b3553;
  border-radius: 0.4285rem;
  font-size: 0.75rem;
  padding: 10px;
}
.commentArea >>> .el-textarea__inner:focus {
  border-color: #01b0e0;
}
.commentArea >>> .el-textarea__inner::placeholder {color: inherit;}

/*===carousel===============================*/

.ReChannelBig >>> button:not(:disabled),
[type="button"]:not(:disabled),
[type="reset"]:not(:disabled),
[type="submit"]:not(:disabled) {
  outline: none!important;
}
.ReChannelBig >>>  button:focus {outline: none!important;}
.el-carousel__arrow {background-color: rgb(62, 85, 110, 0.24);}
.ReChannelBig >>> .el-carousel__arrow--right {right: 0;}
.ReChannelBig >>> .el-carousel__arrow--left {left: 0;}

.el-carousel__item:nth-child(2n) {
  background: url("/img/james.jpg") no-repeat center;
  background-size: contain;
}

.el-carousel__item:nth-child(2n + 1) {
  background: url("/img/lora.jpg") no-repeat center;
  background-size: contain;
}

/*===post-editor===============================*/

.post-editor .bntGroup {
  position: absolute;
  z-index: 1;
  right: 10px;
  top: 0;
}
</style>
